import { api } from "./client";
import type {
    Leak,
    EngagementStatus,
    EngagementHistoryEntry,
    LeakListResponse,
} from "../types/leak";

export type { EngagementStatus, EngagementHistoryEntry };

/**
 * Update the engagement status of a leak
 */
export async function updateEngagementStatus(
    leakId: string,
    newStatus: EngagementStatus,
    notes: string = ""
): Promise<Leak> {
    const res = await api.patch(`/engagement/${leakId}/status`, {
        new_status: newStatus,
        notes,
    });
    return res.data;
}

/**
 * Get the full engagement history for a leak
 */
export async function getEngagementHistory(
    leakId: string
): Promise<EngagementHistoryEntry[]> {
    const res = await api.get(`/engagement/${leakId}/history`);
    return res.data;
}

/**
 * Get all leaks pending client approval
 */
export async function getPendingApprovals(): Promise<LeakListResponse> {
    const res = await api.get("/engagement/pending-approvals");
    return res.data;
}

/**
 * Get all active engagements
 */
export async function getActiveEngagements(): Promise<LeakListResponse> {
    const res = await api.get("/engagement/active");
    return res.data;
}

/**
 * Get all leaks grouped by engagement status (for kanban board)
 */
export async function getEngagementBoard(): Promise<
    Record<EngagementStatus, Leak[]>
> {
    const res = await api.get("/engagement/board");
    return res.data;
}
